export default __webpack_public_path__ + "static/media/bukopin-syariah.06651420.png";